import { useWorkflowExtensions } from '../useWorkflowExtensions';

export const useWorkflowExtension = ({
  workflowId,
}: {
  workflowId: string;
}) => {
  const workflowExtensions = useWorkflowExtensions();
  return workflowExtensions.find(
    workflowExtension => workflowExtension.workflowId === workflowId,
  );
};
